var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExtras(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.02 99H28.98C24.6525 99 20.9325 95.9125 20.135 91.6575L13.375 55.6074C12.8825 52.9799 13.575 50.2899 15.275 48.2249C16.975 46.1624 19.4825 44.9675 22.1575 44.95H22.1875L38.2825 45H52.73L35.9225 71.485L22.2125 50.95H22.1875C20.975 50.9625 20.2375 51.6399 19.905 52.0424C19.5725 52.4475 19.0475 53.3049 19.2725 54.5024L26.0325 90.5524C26.2975 91.9699 27.5375 93 28.98 93H91.02C92.4625 93 93.7025 91.9699 93.9675 90.5524L100.717 54.5525C100.942 53.3475 100.412 52.4875 100.077 52.0825C99.7425 51.6775 98.995 50.9975 97.77 50.9975H72V44.9975H97.77C100.455 44.9975 102.98 46.1825 104.695 48.25C106.41 50.3175 107.11 53.0175 106.615 55.6575L99.865 91.6575C99.0675 95.9125 95.3475 99 91.02 99ZM29.44 50.9725L35.7925 60.4874L41.8125 51H38.27L29.4375 50.9725H29.44Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66 57H54V63H66V57Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90 57H78V63H90V57Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90 81H78V87H90V81Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54 69H42V75H54V69Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78 69H66V75H78V69Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42 81H30V87H42V81Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66 81H54V87H66V81Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 48.7251C59.58 48.7251 57.66 47.9951 56.1975 46.5326C54.78 45.1151 54 43.2326 54 41.2301C54 39.2276 54.78 37.3426 56.1975 35.9276L68.925 23.2001C71.85 20.2751 76.6075 20.2751 79.5325 23.2001C82.4575 26.1251 82.4575 30.8826 79.5325 33.8076L66.805 46.5351C65.3425 47.9976 63.4225 48.7276 61.5025 48.7276L61.5 48.7251ZM74.2275 27.0026C73.8425 27.0026 73.46 27.1476 73.1675 27.4401L60.44 40.1676C59.855 40.7526 59.855 41.7051 60.44 42.2876C61.025 42.8701 61.9775 42.8726 62.5625 42.2876L75.29 29.5601C75.875 28.9751 75.875 28.0226 75.29 27.4376C74.9975 27.1451 74.6125 27.0001 74.23 27.0001L74.2275 27.0026Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtras);
export default __webpack_public_path__ + "static/media/Extras.e3a62474.svg";
export { ForwardRef as ReactComponent };